<!-- src/app/meter/components/meter-analytics/meter-top-consumers/meter-top-consumers.component.html -->

<div class="table-card">
    <h3 class="chart-title">{{ 'meter.analytics.table_top_consumers' | translate }}</h3>

    <table mat-table [dataSource]="data" *ngIf="data.length > 0">
        <ng-container matColumnDef="rank">
            <th mat-header-cell *matHeaderCellDef>{{ 'meter.analytics.col_rank' | translate }}</th>
            <td mat-cell *matCellDef="let item; let i = index">{{ i + 1 }}</td>
        </ng-container>

        <ng-container matColumnDef="nodeId">
            <th mat-header-cell *matHeaderCellDef>{{ 'meter.analytics.col_meter_id' | translate }}</th>
            <td mat-cell *matCellDef="let item">{{ item.nodeId }}</td>
        </ng-container>

        <ng-container matColumnDef="street">
            <th mat-header-cell *matHeaderCellDef>{{ 'meter.analytics.col_street' | translate }}</th>
            <td mat-cell *matCellDef="let item">{{ item.street }}</td>
        </ng-container>

        <ng-container matColumnDef="totalConsumption">
            <th mat-header-cell *matHeaderCellDef>{{ 'meter.analytics.col_consumption' | translate }}</th>
            <td mat-cell *matCellDef="let item">{{ item.totalConsumption }} {{ 'meter.analytics.unit_m3' | translate }}</td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>

    <div *ngIf="data.length === 0" class="no-data">
        {{ 'meter.analytics.no_data' | translate }}
    </div>
</div>
